/**
 * byId.js
 * Written by: Alex Kasemir
 */

import format from 'date-fns/format';

import userActions from 'store/user/actions';
import notificationActions from 'store/notification/actions';

/**
 * Description of the byId reducer
 */
const byId = (state = {}, action) => {
  switch (action.type) {
    case notificationActions.GET_NOTIFICATIONS_SUCCESS:
      return action.results.reduce((newState, notification) => {
        return {
          ...newState,
          [notification.id]: {
            ...notification,
          },
        };
      }, state);
    case notificationActions.CLICK_NOTIFICATION_SUCCESS: {
      const viewed_ts = action.data.viewed_ts || state[action.data.id].viewed_ts; // eslint-disable-line
      return {
        ...state,
        [action.data.id]: {
          ...action.data,
          viewed_ts,
        },
      };
    }
    case notificationActions.VIEW_NOTIFICATIONS_START:
      return action.data.reduce((newState, notification) => {
        return {
          ...newState,
          [notification.id]: {
            ...notification,
            viewed_ts: format(new Date()),
          },
        };
      }, state);
    case userActions.REMOVE_TOKEN_SUCCESS:
      return {};
    default:
      return state;
  }
};

export default byId;
